export const checkParasitePresence = (pList, query) => {
    if (!pList || !query) return false;
    try {
        let list = pList;
        if (typeof list === 'string') {
            try {
                list = JSON.parse(pList.replace(/'/g, '"'));
            } catch (e) {
                list = pList.split(',').map(s => s.trim());
            }
        }
        if (!Array.isArray(list)) return false;
        return list.some(p => p.toLowerCase().includes(query.toLowerCase()));
    } catch (err) {
        console.error("Error checking parasite presence:", err);
        return false;
    }
};

export const getAuthHeader = () => {
    const token = localStorage.getItem("token");
    return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};
